import { getRootPath } from './rootPath';

export const location = {
    href(url) {
        const $window = angular.element(document).injector().get('$window');
        $window.location.href = getRootPath() + url;
    }
};

export function open(url) {
    const $window = angular.element(document).injector().get('$window');
    return $window.open(getRootPath() + url, '_blank');
}
